import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CompassSVG = function CompassSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm7.07 13.77L18 18l-2.23 5.07a1.49 1.49 0 01-1.38.93h-.1A1.49 1.49 0 0113 22.9l-2.9-11a1.52 1.52 0 01.38-1.42 1.55 1.55 0 011.01-.48 1.57 1.57 0 01.37.05l11 2.9a1.49 1.49 0 01.17 2.82z"
  }));
};
CompassSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CompassSVG);